import { render, staticRenderFns } from "./contact-form-message-info-cmp.vue?vue&type=template&id=ce594fd8&scoped=true"
import script from "./contact-form-message-info-cmp.vue?vue&type=script&lang=js"
export * from "./contact-form-message-info-cmp.vue?vue&type=script&lang=js"
import style0 from "./contact-form-message-info-cmp.vue?vue&type=style&index=0&id=ce594fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce594fd8",
  null
  
)

export default component.exports